import moment from "moment";

export const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export const TIER_FREE = "free";
export const TIER_PREMIUM = "premium";
export const PRICE_PER_USER = 5.00;

export const STRIPE_API_KEY = IS_DEV ? "pk_test_Bi5O4safKW4DvBwh99J1HAG0" : "pk_live_kWczCayw1KnYLwn21g5Hk9sb";

export const SHORTCUT = {
    CUSTOM: "custom",
    LAST_MONTH: "last-month",
    LAST_WEEK: "last-week",
    THIS_MONTH: "this-month",
    THIS_WEEK: "this-week",
    ALL_TIME: "all-time"
};

export const NO_ITEM_SELECTED_VALUE = "NO_ITEM_SELECTED_VALUE";
export const FORMAT_REPORTING = "D-M-YYYY";
export const ALL_TIME_FROM = moment("1-1-1950", FORMAT_REPORTING);
export const ALL_TIME_TO = moment("1-1-2050", FORMAT_REPORTING);
export const ALL_TIME_TEXT = "All time";
export const ALL_TIME_TEXT_URL = "all-time";


// WEBPACK FOOTER //
// ./src/constants.js